module.exports = __webpack_public_path__ + "img/letter_of_wishes.6a82ea03.svg";